namespace Nobox {
    export interface ChatroomsListRequest extends Serenity.ListRequest {
        TagsIds?: number[];
        Room?: boolean;
        RoomId?: number;
        IsArchived?: boolean;
        Status?: number;
        Chat?: number;
        UserIds?: number[];
    }
}
